import { render } from "./vhpHeader.vue?vue&type=template&id=8f8fb1be"
import script from "./vhpHeader.vue?vue&type=script&lang=js"
export * from "./vhpHeader.vue?vue&type=script&lang=js"

import "./vhpHeader.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__